import { generateMedia, pxToRem } from 'styled-media-query'

import { SCREEN_SIZES } from './constants'

interface BreakpointsInterface {
  xs: string,
  sm: string,
  md: string,
  lg: string,
  xl: string,
  xxl: string,
  [key: string]: string
}

const breakpointsInRem = pxToRem({
  xs: SCREEN_SIZES.XS,
  sm: SCREEN_SIZES.SM,
  md: SCREEN_SIZES.MD,
  lg: SCREEN_SIZES.LG,
  xl: SCREEN_SIZES.XL,
  xxl: SCREEN_SIZES.XXL
})

const customMedia = generateMedia<BreakpointsInterface>(breakpointsInRem)

export default customMedia
